import { PLATFORM_SMB_ELVN, PLATFORM_SMB_ELAVON_DOTCOM, SITE_SECTION_WELCOME } from "#constants/reportingData.ts";
import { createTracker } from "@repo/analytics";

const { trackPageView, trackClick } = createTracker({
  platformPrefix: PLATFORM_SMB_ELVN,
  platform: PLATFORM_SMB_ELAVON_DOTCOM,
  defaultSiteSection: SITE_SECTION_WELCOME,
});

// Maintain existing API signature
export const trackEventOnLoad = (pageName: string, eventData?: Record<string, unknown>): void => {
  trackPageView({
    siteSection: SITE_SECTION_WELCOME,
    subSiteSection: pageName,
    includeSubSiteSectionInPageName: false,
    ...eventData,
  });
};
export const trackEventOnClick = (eventData: Record<string, unknown>): void => {
  trackClick({
    siteSection: SITE_SECTION_WELCOME,
    includeSubSiteSectionInPageName: false,
    ...eventData,
  });
}